import { createSlice } from "@reduxjs/toolkit";
import { assign } from "lodash";
import { is4xxStatusCode } from "common/number-helper";
import { dialogsList, MessagesDialogFunctionName } from "components/frame/helper";
import { createdRejectedComment, updatedRejectedComment } from "components/workspaces/store/api";
import { language } from "language/default";
const initialState = {
    isReadOnly: true,
    messages: [],
    title: ""
};
const slice = createSlice({
    extraReducers: (builder) => {
        builder
            .addMatcher(createdRejectedComment, (state, { payload: comment }) => {
            if (comment?.data && is4xxStatusCode(comment.status)) {
                const responseBodyErrors = comment?.data;
                state.messages = [{ message: responseBodyErrors?.message }];
                state.title = language.en.widgets.freeText.invalidComment;
                state.isReadOnly = false;
            }
        })
            .addMatcher(updatedRejectedComment, (state, { payload: comment }) => {
            if (comment?.data && is4xxStatusCode(comment.status)) {
                const responseBodyErrors = comment?.data;
                state.messages = [{ message: responseBodyErrors?.message }];
                state.title = language.en.widgets.freeText.invalidComment;
                state.isReadOnly = false;
            }
        });
    },
    initialState,
    name: "messagesDialogReducers",
    reducers: {
        closeDialog: (state) => {
            state.messages = [];
            const oldAction = dialogsList.get(state?.functionName ?? MessagesDialogFunctionName.Default)?.action;
            dialogsList.set(state?.functionName ?? MessagesDialogFunctionName.Default, { action: oldAction, isOpened: false });
            state.customProp = undefined;
        },
        removeAllPropsFromMessageDialog: (state) => ({
            ...state,
            buttonClicked: undefined,
            buttons: {},
            customProp: undefined,
            functionName: MessagesDialogFunctionName.Default,
            hasCustomFooter: false,
            isPrimaryButtonDelete: false,
            isReadOnly: true,
            messages: [],
            primaryButtonLabel: undefined,
            secondaryButtonLabel: undefined,
            title: "",
            type: undefined
        }),
        setExportCffModel: (state, action) => {
            state.isCffExportRequested = action.payload;
        },
        setIsReadOnly: (state, action) => {
            state.isReadOnly = action.payload;
        },
        setMessagesDialog: (state, action) => {
            assign(state, action.payload);
            const oldAction = dialogsList.get(state?.functionName ?? MessagesDialogFunctionName.Default)?.action;
            dialogsList.set(state?.functionName ?? MessagesDialogFunctionName.Default, { action: oldAction, isOpened: true });
        }
    }
});
export const messagesDialogReducers = slice.reducer;
export const { setMessagesDialog, setIsReadOnly, removeAllPropsFromMessageDialog, setExportCffModel, closeDialog } = slice.actions;
